import { useEffect } from 'react';
import Breadcrumb from '../Breadcrumb';
import Section from '../Section';
import BrandSection from '../Section/BrandSection';
import ServiceSection from '../Section/ServiceSection/index.jsx';
import TestimonialSliderStyle3 from '../Slider/TestimonialSliderStyle3.jsx';
import ContactSectionStyle2 from '../Section/ContactSection/ContactSectionStyle2.jsx';
import { pageTitle } from '../../helpers/PageTitle';

const serviceData = [
  {
    icon: 'fa6-solid:hammer',
    title: 'Custom Cabinetry & Millwork',
    subTitle:
      'Bespoke cabinetry and millwork tailored to your style, needs, and space.',
    imgUrl: '/images/service-1.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:ruler-combined',
    title: 'Trim, Molding & Finish Work',
    subTitle:
      'Clean lines and refined finishes that create cohesive, polished interiors.',
    imgUrl: '/images/service-2.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:tree',
    title: 'Decks, Pergolas & Outdoor Wood Structures',
    subTitle:
      'Durable outdoor structures designed for beauty, function, and long-term performance.',
    imgUrl: '/images/service-3.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:border-all',
    title: 'Wall Paneling & Feature Walls',
    subTitle:
      'Elevate interiors with custom paneling and statement wood features.',
    imgUrl: '/images/service-4.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:grip-lines',
    title: 'Staircases & Railings',
    subTitle:
      'Precision-built stairs and handrails that blend safety with design.',
    imgUrl: '/images/service-5.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:store',
    title: 'Commercial & Retail Millwork',
    subTitle:
      'High-quality millwork for branded, durable commercial environments.',
    imgUrl: '/images/service-6.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:door-open',
    title: 'Doors, Trim & Hardware Installation',
    subTitle:
      'Professional installation ensuring clean alignment and long-term performance.',
    imgUrl: '/images/service-3.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:paintbrush',
    title: 'Wood Restoration & Refinishing',
    subTitle:
      'Restore and protect wood surfaces with expert refinishing and repair.',
    imgUrl: '/images/service-4.webp',
    href: '/service/services-details',
  },
];

const brandData = [
  { imgUrl: '/images/brand/brand-1-1.png' },
  { imgUrl: '/images/brand/brand-1-2.png' },
  { imgUrl: '/images/brand/brand-1-3.png' },
  { imgUrl: '/images/brand/brand-1-4.png' },
  { imgUrl: '/images/brand/brand-1-5.png' },
  { imgUrl: '/images/brand/brand-1-6.png' },
  { imgUrl: '/images/brand/brand-1-7.png' },
  { imgUrl: '/images/brand/brand-1-8.png' },
  { imgUrl: '/images/brand/brand-1-9.png' },
  { imgUrl: '/images/brand/brand-1-10.png' },
  { imgUrl: '/images/brand/brand-1-11.png' },
  { imgUrl: '/images/brand/brand-1-12.png' },
];

const testimonialData = [
  {
    imgUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    subTitle:
      "The team did an outstanding job on our kitchen cabinets. The finishing and detailing were beyond our expectations. Highly professional and delivered exactly on time.",
    rating: '5',
    name: 'Michael Thompson',
  },
  {
    imgUrl: 'https://randomuser.me/api/portraits/women/44.jpg',
    subTitle:
      "We hired them for custom wardrobes and interior doors, and the craftsmanship was exceptional. Very reliable and easy to work with throughout the project.",
    rating: '4.5',
    name: 'Sarah Williams',
  },
  {
    imgUrl: 'https://randomuser.me/api/portraits/men/65.jpg',
    subTitle:
      "From design to installation, everything was handled perfectly. Our living room wall paneling looks amazing. I would definitely recommend their carpentry services.",
    rating: '4',
    name: 'David Anderson',
  },
];


export default function ServicesPage() {
  pageTitle('Services');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb title="Our Services" bgUrl="/images/page_header_1.jpeg" />

      <Section pt="120" pb="80" ptLg="80">
        <ServiceSection
          data={serviceData}
          sectionTitleUp="Our Services"
          sectionTitle="Precision. Function. Beauty."
          sectionSubTitle="At HybridOne Carpentry, we provide a complete range of custom carpentry and millwork services designed to enhance the beauty, functionality, and value of residential and commercial spaces across Houston."
          sectionBtnText="Find More Services"
          sectionBtnUrl="/service"
          textVariant="text-white"
        />
      </Section>

      <Section pt="110" ptLg="80" pb="110" pbLg="80" >
        <BrandSection data={brandData} />
      </Section>

      {/* <Section pt='120' pb="120" ptLg="75">
        <WorkingProcessSection
          sectionTitleUp="Working Process"
          sectionTitle="Check How We Work in <br/>  Easy Steps"
          data={stepData}
        />
      </Section> */}

      <Section>
        <div className="cs_pb_131 cs_pt_131 bg-accent">
          <TestimonialSliderStyle3 data={testimonialData} />
        </div>
      </Section>

      <Section pt="80" ptLg="75" pb="85" pbLg="55">
        <ContactSectionStyle2
          sectionTitle="Let’s Build Your Vision"
          sectionTitleUp="Contact Hybrid One Carpentry"
          sectionSubTitle="Custom cabinetry, millwork, doors, and furniture tailored to your space. Serving Greater Houston with precision craftsmanship — request a free estimate today."
          featureList={[
            'Free site visit & estimate',
            'Licensed, insured workmanship',
            'Custom design options',
            'High-quality materials',
            'On-time project delivery',
          ]}
          contactInfo={[
            {
              imgUrl: '/images/icons/contact_icon_1.svg',
              titleUp: 'Have Any Question?',
              title: '+1 (281) 409 5882',
              textColor: 'text-primary',
            },
            {
              imgUrl: '/images/icons/contact_icon_2.svg',
              titleUp: 'Send Email',
              title: 'manager@hybridonecarpentry.com',
              textColor: 'text-primary',
            },
          ]}
        />
      </Section>
    </>
  );
}
